






















import Vue from 'vue'
import { mdiAccount, mdiDomain, mdiMapMarker } from '@mdi/js'
import { BaseDataItem } from '@/components'
import { IShippingAddress } from '@/models'

export default Vue.extend({
    name: 'Address',

    components: { BaseDataItem },

    props: {
        address: {
            type: Object as () => IShippingAddress,
            required: true,
        },
    },

    data: () => ({
        mdiAccount,
        mdiDomain,
        mdiMapMarker,
    }),

    computed: {
        fullName(): string {
            const { firstName, lastName } = this.address

            return `${firstName ?? ''} ${lastName ?? ''}`
        },
    },
})
